import { render } from "./TableClassic.vue?vue&type=template&id=763d565e"
import script from "./TableClassic.vue?vue&type=script&lang=js"
export * from "./TableClassic.vue?vue&type=script&lang=js"

import "./TableClassic.vue?vue&type=style&index=0&id=763d565e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__